import * as React from "react";
import InputField from "../../generic/inputField";
import EdButton from "../../generic/edButton";
import LoginFormBtmTxt from "../generic/loginFormBtmTxt";
import "../../../assets/scss/Login/login/forms/loginIdForm.scss";
import "../../../assets/scss/Login/login/generic/loginInput.scss";
import LoginErrMsg from "../generic/loginErrMsg";
import { UserIdExp } from "../../utils/regex";

export interface ILoginIdFormProps {
  disableForm: boolean; // used to disable/enable form from parent
  userName?: string; // default username for the field
  errorMsg?: string; // error message that came from api
  onSubmit: (userName: string) => void; // function to be called on submit
  onRemoveError: () => void; // removes the errorMsg
}

const LoginIdForm: React.FC<ILoginIdFormProps> = (props) => {
  // stores the userName entered by the user
  const [userName, setUserName] = React.useState(props.userName || "");

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    props.onSubmit(userName);
  }

  function onSetUserName(value: string) {
    // if errorMsg is present, then remove it
    if (props.errorMsg) {
      props.onRemoveError();
    }

    if (UserIdExp.test(value)) {
      setUserName(value);
      return value;
    } else {
      setUserName(userName);
      return userName;
    }
  }

  return (
    <div className="login_form loginid_form">
      <form onSubmit={handleSubmit} className="mg-b60">
        <label className="inp_lbl mg-b5 ib">Login ID</label>
        <InputField
          id="userID"
          defaultValue={userName}
          onChange={onSetUserName}
          onBlur={() => {}}
          className="login_inp mg-b40"
          placeholder="Eg:5678987"
          maxLength={24}
          autoComplete="off"
        />

        {/* Show error if any */}
        {props.errorMsg && (
          <LoginErrMsg className="mg-b40">{props.errorMsg}</LoginErrMsg>
        )}

        {/* Disable button if username is blank or form is disabled from outside */}
        <EdButton
          value="Proceed"
          btnTyp="primary"
          className="submit_btn"
          disabled={props.disableForm || !userName}
        />
      </form>

      <LoginFormBtmTxt />
    </div>
  );
};

export default LoginIdForm;
